import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Services from '@/components/Services'
import About from '@/components/About'
import Contact from '@/components/Contact'
import NewsList from '@/components/NewsList'
import News from '@/components/News'
import Subscribe from '@/components/Subscribe'
import Partner from '@/components/Partner'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/partner',
      name: 'Partner',
      component: Partner
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/news/media/:media_id/:type',
      name: 'News',
      component: News
    },
    {
      path: '/news/list/:type',
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/subscribe',
      name: 'Subscribe',
      component: Subscribe
    },
    {
      path: '/subscribe/:token',
      name: 'SubscribeToken',
      component: Subscribe
    },
    {
      path: '/services/:type',
      name: 'Services',
      component: Services
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js